import * as React from 'react';
// CampaignAdStatsContainer.jsx
import { useParams } from "react-router-dom";
import StatsContainer from "../common/StatsContainer";
import { useGetCampaignAdStatsQuery } from "../../services/campaign";

export const CampaignAdStatsContainer = () => {
  const { campaignId } = useParams();
  
  return (
    <StatsContainer 
      id={campaignId}
      useGetStatsQuery={useGetCampaignAdStatsQuery}
      title="Campaign Ad Stats"
      showDateFilter={true}
    />
  );
};

export default CampaignAdStatsContainer;
